module.exports = __webpack_public_path__ + "static/media/lobby.14608f6d.jpg";